/* Public Pages */
export const HOME = '/';
export const SEARCH_RESULTS = '/searchresults';
export const HOTEL = '/hotel';
export const UMRAH_GUIDE = '/umrah-guide';

/* Static Pages */
export const ABOUT_US = '/about-us';
export const CONTACT_US = '/contact-us';
export const PRIVACY_POLICIES = '/privacy-policies';
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';

/* Auth Pages */
export const LOGIN = '/login';
export const REGISTER = '/register';
export const VERIFY = '/verify';
export const RESEND_CODE = '/resend-code';
export const RESET_PASSWORD = '/reset-password';
export const FORGOT_PASSWORD = '/forgot-password';

/* User */
export const PROFILE = '/profile';
export const BOOKINGS = '/bookings';
export const CHANGE_PASSWORD = '/change-password';
export const PAYMENT = '/payment';


/* B2B */
export const B2B_LOGIN = '/b2b-login';
export const B2B_REGISTER = '/b2b-register';
